import React, { useEffect } from 'react'
import "./PageLoader.scss";

interface IProps {
	autoShow?: boolean;
	cls?: string;
	style?: any;
	thumbStyle?: any;
}

interface IState {
	state: any;
}

export class PageLoader extends React.Component<IProps> {
	public static instance?: PageLoader;
	element: any;
	count: number;
	hidingTimerId: any;

	static defaultProps = {
		autoShow: false,
		cls: '',
		style: {},
		thumbStyle: {}
	}

	constructor(props: IProps) {
		super(props)
		this.element = null;
		this.count = 0;
		this.hidingTimerId = null;
		this.state = {
			state: 'hidden'
		}
	}

	state: IState = {
		state: {
			state: 'hidden'
		}
	}

	initElement = (el: any) => {
		this.element = el;
		if (this.props.autoShow && !this.count)
			PageLoader.show();
	}

	render() {
		const { cls, style, thumbStyle } = this.props
		const className = `page-loader ${cls}`

		return (
			<div className={className} style={style} data-state={this.state.state} ref={this.initElement}>
				<div className="page-loader-progress" style={thumbStyle}></div>
			</div>
		)
	}

	toHiddenState = () => {
		this.element.setAttribute('data-state', 'hidden')
	}

	UNSAFE_componentWillMount() {
		PageLoader.instance = this;
	}

	UNSAFE_componentWillUnmount() {
		clearTimeout(this.hidingTimerId);
		delete PageLoader.instance;
	}

	static show() {
		const _this = PageLoader.instance;

		if (!_this || ++_this.count > 1)
			return

		clearTimeout(_this.hidingTimerId)

		const { element } = _this
		if (element && element.querySelector ) {
			const progressEl = element.querySelector('.page-loader-progress')

			element.setAttribute('data-state', 'hidden')
			// the only working way to restart a transition on firefox
			progressEl.outerHTML = progressEl.outerHTML;
			let offsetHeight = element.offsetHeight;
			element.setAttribute('data-state', '');
			offsetHeight = element.offsetHeight;
			element.setAttribute('data-state', 'running');
		}
	}

	static hide() {
		const _this = PageLoader.instance;
		if (!_this || --_this.count > 0)
			return;

		_this.element.setAttribute('data-state', 'finishing');
		_this.hidingTimerId = setTimeout(_this.toHiddenState, 500);
	}

	static hideAll() {
		const _this = PageLoader.instance;
		if (_this) {
			_this.count = 1;
			PageLoader.hide();
		}
	}

	static isVisible() {
		const _this = PageLoader.instance;
		return _this ? _this.element.getAttribute('data-state') != 'hidden' : false;
	}
}

export const FallbackLoader = (props: {}) => {

	useEffect(() => {
		PageLoader.show();
		return () => (PageLoader.hide());
	}, []);

	return null;
}
